const FONT_SIZE = 8;

const createTooltipConfig = () => ({
  showTotal: true,
});

const createAxisLabels = (fontSize = FONT_SIZE) => ({
  bold: true,
  fontSize,
});

const createCommonStackedConfig = (graphDates, theme, options = {}) => {
  const { scaleMax, fontSize = FONT_SIZE, size, timeLabelCount } = options;
  const config = {
    theme,
    style: {
      chart: {
        grid: {
          x: {
            showHorizontalLines: true,
            linesThickness: 0.3,
            timeLabels: {
              ...createAxisLabels(fontSize),
              values: graphDates,
            },
          },
          y: {
            axisLabels: createAxisLabels(fontSize),
          },
        },
        tooltip: createTooltipConfig(),
      },
    },
  };
  if (scaleMax) {
    config.style.chart.grid.scale = { scaleMax };
  }

  if (size) {
    config.style.chart.width = size.width;
    config.style.chart.height = size.height;
  }

  if (timeLabelCount) {
    Object.assign(config.style.chart.grid.x.timeLabels, {
      rotation: 0,
      autoRotate: { enable: false },
      showOnlyAtModulo: true,
      modulo: timeLabelCount,
    });
  }

  return config;
};

const createStackedChartConfig = ({ fontSize = FONT_SIZE, hideSegmentLabelsUnder = null } = {}) => ({
  totalValues: createAxisLabels(fontSize),
  dataLabels: {
    hideEmptyValues: true,
    hideUnderValue: hideSegmentLabelsUnder,
    fontSize,
    bold: true,
  },
});

const createConfigWithChartType = (graphDates, chartType, theme, options = {}) => {
  const config = createCommonStackedConfig(graphDates, theme, options);
  config.style.chart[chartType] = createStackedChartConfig(options);

  return config;
};

export const stackedBarConfig = (graphDates, theme, options = {}) =>
  createConfigWithChartType(graphDates, 'bars', theme, options);

export const stackedLineConfig = (graphDates, theme) =>
  createConfigWithChartType(graphDates, 'lines', theme);

export const xyConfig = (graphDates, theme) => ({
  theme,
  chart: {
    tooltip: createTooltipConfig(),
    grid: {
      showHorizontalLines: true,
      labels: {
        fontSize: FONT_SIZE,
        xAxisLabels: {
          fontSize: FONT_SIZE,
          values: graphDates || [],
        },
      },
    },
  },
  line: {
    useGradient: false,
    dot: {
      useSerieColor: false,
      strokeWidth: 2,
    },
  },
  bar: {
    periodGap: 0.01,
    labels: {
      show: true,
    },
  },
});

export const xyDataset = (allSeries, chartType, graphPoints, seriesLabels = {}) =>
  allSeries.map(name => ({
    name: seriesLabels[name] || name,
    type: chartType,
    smooth: true,
    series: graphPoints.map(p => p[name]),
  }));

export const stackedDataset = (allSeries, graphPoints, seriesLabels = {}) =>
  allSeries.map(name => ({
    name: seriesLabels[name] || name,
    series: graphPoints.map(p => p[name]),
  }));
